import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { createRoleTemplatePageMessages } from './createRoleTemplatePage.messages';
import { RoleTemplateForm } from '@/forms/RoleTemplateForm';
import { DashboardPageContainer } from '@/components/layout/DashboardPageContainer';

import { Button } from '@/components/ui/button';
import { createRoleTemplate } from '@/api/services/role-templates/createRoleTemplate';
import { ApiError } from '@/api/ApiError';
import { UNKNOWN_ERROR_API_ERROR } from '@/api/helpers/unknownError';
import { ROUTES } from '@/routes';
import type { CreateRoleTemplateRequest } from 'schemas';

export function CreateRoleTemplatePage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (formData: CreateRoleTemplateRequest) => {
    try {
      setIsSubmitting(true);

      await createRoleTemplate(formData);

      toast.success(createRoleTemplatePageMessages.successMessage);
      navigate(ROUTES.DASHBOARD_ROLE_TEMPLATES);
    } catch (err) {
      const apiError = err instanceof ApiError ? err : UNKNOWN_ERROR_API_ERROR;
      toast.error(apiError.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(ROUTES.DASHBOARD_ROLE_TEMPLATES);
  };

  return (
    <DashboardPageContainer
      headline={createRoleTemplatePageMessages.title}
      subheading={createRoleTemplatePageMessages.subtitle}
      cta={
        <Button
          variant="outline"
          onClick={handleCancel}
          disabled={isSubmitting}
        >
          {createRoleTemplatePageMessages.backToRoleTemplates}
        </Button>
      }
    >
      <div className="mx-auto max-w-2xl">
        <RoleTemplateForm
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          onCancel={handleCancel}
        />
      </div>
    </DashboardPageContainer>
  );
}
